import { getDeivceType } from './browser';

let copyTimeout = null;

export const popupCenter = (url, title = 'Hey There!', w = 550, h = 650) => {
  const dualScreenLeft = window.screenLeft || window.screenX;
  const dualScreenTop = window.screenTop || window.screenY;
  const width =
    window.innerWidth || document.documentElement.clientWidth || screen.width;
  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    screen.height;
  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `scrollbars=yes, width=${w / systemZoom}, height=${
      h / systemZoom
    }, top=${top}, left=${left}`,
  );
  if (window.focus) newWindow.focus();
};

export const shareProfile = (type, page, name, setCopied) => {
  switch (type) {
    case 'WhatsApp': {
      const deviceType = getDeivceType();
      const whatsappMessage = `I found a library full of really cool video templates designed by ${name}. Check them out on InVideo.io. (${encodeURIComponent(
        page,
      )})`;
      let url = `https://web.whatsapp.com/send?text=${whatsappMessage}`;
      if (deviceType !== 'desktop') {
        url = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
      }
      window.open(url, '_blank');
      break;
    }
    case 'Facebook': {
      const facebookMessage = `I found a library full of really cool #video templates designed by #${name}. Check them out on InVideo.io. \n ${page}`;
      const url = `https://www.facebook.com/sharer/sharer.php?u=${page}&quote=${encodeURIComponent(
        facebookMessage,
      )}`;
      popupCenter(url);
      break;
    }
    case 'Twitter': {
      const twitterMessage = `I found a library full of really cool #video templates designed by #${name}. Check them out on @InVideoOfficial. ${page}`;
      const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        twitterMessage,
      )}`;
      popupCenter(url);
      break;
    }
    case 'LinkedIn': {
      const linkedinMessage = `You can now scale your #video marketing efforts with these stunning templates! Check out ${name}'s @InVideo portfolio: - ${page}`;
      const url = `https://www.linkedin.com/shareArticle?mini=true&url=${page}&summary=${encodeURIComponent(
        linkedinMessage,
      )}`;
      popupCenter(url, 'Hey there', 550, 650);
      break;
    }
    case 'Email': {
      const mailSubject = 'Save time with these video templates';
      const mailBody = `Hi, As I know video creation can be a daunting task! That’s why I think this library of easily customisable templates might come in handy. Beautifully designed by ${name} on InVideo: ${page}. Pick any design and turn it into your very own video.`;
      window.location.href = `mailto:?subject=${mailSubject}&body=${mailBody}`;
      break;
    }
    case 'Copy Link': {
      if (copyTimeout) {
        clearTimeout(copyTimeout);
      }

      setCopied(true);
      copyTimeout = setTimeout(() => {
        setCopied(false);
      }, 5000);

      const copyDummy = document.createElement('input');
      copyDummy.value = page;
      document.body.appendChild(copyDummy);
      copyDummy.select();
      document.execCommand('copy');
      document.body.removeChild(copyDummy);
      break;
    }
    default: {
      // eslint-disable-next-line no-alert
      alert('Something wrong');
    }
  }
};
